export default __webpack_public_path__ + "resources/icons/n132-3d16.webp";